import { BaseStepPropsV2 } from '../../common/v2/BaseStepV2.types';

export interface PickAProductProps extends BaseStepPropsV2 {
  label?: string;
  useAbsoluteHeaderNavigation?: boolean;
}

export enum Variant {
  v1 = 'v1',
  v2 = 'v2',
  v3 = 'v3',
}

export const DEFAULT_PLAN_KEY = '0';
export const PRICE_TEST_DEFAULT_PLAN_KEY = '4';
export const WEEKLY_PRICES_TEST_DEFAULT_PLAN_KEY = '8';
